import React from 'react'
import FontAwesome from 'react-fontawesome'
import { Translation } from 'react-i18next'
import mobileView from '../../../utils/mobile.utils'
import { useSelector } from 'react-redux'
import { getTotalApplication } from '../../../selectors/employer/applications.selector'
/**
 * @author Pragya Gupta
 */

const front = (concept) => {
  switch (concept) {
    case 'LIGHT_ENTREPRENEURS':
      return 'employer.nav2.lightE'
    case 'ASSIGNMENTS':
      return 'employer.nav2.assignments'
    case 'APPLICATIONS':
      return 'employer.nav2.app'
    case 'WORKSHIFTS':
      return 'employer.nav2.work'
    case 'PROFILE':
      return 'employer.dashboard.asetu'
    case 'CONTRACT':
      return 'employer.nav2.contract'
  }
}

const NavIcon = ({
  name,
  size,
  sectionClass,
  iconClass,
  content,
  userLogged
}) => {
  // KAS-406 Get total applications count
  const getTotalApplicationCount = useSelector(getTotalApplication)
  return (
    <Translation>
      {(t) => {
        return (
          <div
            className={
              mobileView && userLogged !== false
                ? 'mobile-nav-icon'
                : sectionClass
            }
          >
            {' '}
            {/* userLogged is passed as false in Navigation component */}
            <FontAwesome name={name} size={size} className={iconClass} />
            <p style={{ fontSize: '14px', maxWidth: '85px' }}>
              {t(front(content))}{' '}
              {content === 'APPLICATIONS'
                ? getTotalApplicationCount.total_application +
                  '(' +
                  getTotalApplicationCount.total_newapplication +
                  ' new)'
                : null}
            </p>
          </div>
        )
      }}
    </Translation>
  )
}
export default NavIcon
